import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiStar, FiUsers, FiCrown } = FiIcons;

const ToolCard = ({ tool, viewMode }) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  if (viewMode === 'list') {
    return (
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        whileHover={{ x: 10 }}
        className="bg-gradient-to-r from-gray-800/50 to-gray-900/50 p-6 rounded-xl border border-gray-700/50 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              tool.isPremium 
                ? 'bg-gradient-to-r from-cyan-500 to-blue-500' 
                : 'bg-gradient-to-r from-green-500 to-emerald-500'
            }`}>
              <SafeIcon icon={tool.icon} className="text-white text-xl" />
            </div>
            <div>
              <div className="flex items-center space-x-2">
                <h3 className="text-lg font-orbitron font-bold text-white">{tool.name}</h3>
                {tool.isPremium && <SafeIcon icon={FiCrown} className="text-yellow-400 text-sm" />}
              </div>
              <p className="text-gray-300 font-poppins text-sm">{tool.description}</p>
              <div className="flex items-center space-x-4 mt-2 text-xs text-gray-400">
                <div className="flex items-center space-x-1">
                  <SafeIcon icon={FiUsers} />
                  <span>{tool.usage}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <SafeIcon icon={FiStar} />
                  <span>{tool.rating}</span>
                </div>
              </div>
            </div>
          </div>
          <Link to={tool.link} onClick={handleClick}>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={`px-6 py-2 rounded-full font-poppins font-medium transition-all duration-300 flex items-center space-x-2 ${
                tool.isPremium
                  ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white glow-button'
                  : 'bg-gradient-to-r from-green-600/20 to-emerald-600/20 border border-green-500/30 text-green-300 hover:from-green-600/40 hover:to-emerald-600/40'
              }`}
            >
              <span>{tool.isPremium ? 'Try Premium' : 'Try Free'}</span>
              <SafeIcon icon={FiArrowRight} />
            </motion.button>
          </Link>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      whileHover={{ y: -5 }}
      className={`p-6 rounded-2xl border backdrop-blur-sm transition-all duration-300 ${
        tool.isPremium
          ? 'bg-gradient-to-br from-cyan-800/50 to-blue-800/50 border-cyan-500/50 hover:border-cyan-400/70'
          : 'bg-gradient-to-br from-green-800/50 to-emerald-800/50 border-green-500/50 hover:border-green-400/70'
      }`}
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
          tool.isPremium 
            ? 'bg-gradient-to-r from-cyan-500 to-blue-500' 
            : 'bg-gradient-to-r from-green-500 to-emerald-500'
        }`}>
          <SafeIcon icon={tool.icon} className="text-white text-xl" />
        </div>
        {tool.isPremium && <SafeIcon icon={FiCrown} className="text-yellow-400" />}
      </div>

      <h3 className="text-xl font-orbitron font-bold text-white mb-2">{tool.name}</h3>
      <p className="text-gray-300 font-poppins text-sm mb-4">{tool.description}</p>

      <div className="flex items-center justify-between text-xs text-gray-400 mb-4">
        <div className="flex items-center space-x-1">
          <SafeIcon icon={FiUsers} />
          <span>{tool.usage}</span>
        </div>
        <div className="flex items-center space-x-1">
          <SafeIcon icon={FiStar} />
          <span>{tool.rating}</span>
        </div>
      </div>

      <Link to={tool.link} onClick={handleClick}>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className={`w-full py-3 rounded-full font-poppins font-medium transition-all duration-300 flex items-center justify-center space-x-2 ${
            tool.isPremium
              ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white glow-button'
              : 'bg-gradient-to-r from-green-600/20 to-emerald-600/20 border border-green-500/30 text-green-300 hover:from-green-600/40 hover:to-emerald-600/40'
          }`}
        >
          <span>{tool.isPremium ? 'Try Premium' : 'Try Free'}</span>
          <SafeIcon icon={FiArrowRight} />
        </motion.button>
      </Link>
    </motion.div>
  );
};

export default ToolCard;